export const SET_USER = 'SET_USER';
export const SET_USER_UNAUTHENTICATED = 'SET_USER_UNAUTHENTICATED';
export const RESET_USER = 'RESET_USER';
